export const toParameterDefinition = (g) => {
    return Object.assign(Object.assign({}, g), { type: 'Array<Parameter>', defaultValue: [] });
};
export const toGenericTypeParameterDefinition = (x) => {
    delete x.type;
    return x;
};
export const constructParameters = (parameterDefs) => {
    const parameters = [];
    parameterDefs === null || parameterDefs === void 0 ? void 0 : parameterDefs.map(ps => {
        parameters.push(constructParameterSpecification(ps));
    });
    return parameters;
};
const constructParameterSpecification = (parameterDef) => {
    // validate here
    var _a;
    return Object.assign(Object.assign({}, parameterDef), { required: (_a = parameterDef.required) !== null && _a !== void 0 ? _a : false, errors: [] });
};
export const deconstructParameters = (parameters) => {
    return parameters.map(p => deconstructParameter(p));
};
const deconstructParameter = (parameter) => {
    const stripProperties = ({ name, label, description, type, required, visibility, group, control, defaultValue, }) => {
        const strippedParameter = { name, type };
        if (!!label) {
            strippedParameter.label = label;
        }
        if (!!description) {
            strippedParameter.description = description;
        }
        if (required === false || !!required) {
            strippedParameter.required = required;
        }
        if (!!visibility) {
            strippedParameter.visibility = visibility;
        }
        if (!!group) {
            strippedParameter.group = group;
        }
        if (!!control) {
            strippedParameter.control = control;
        }
        if (defaultValue === false || !!defaultValue) {
            strippedParameter.defaultValue = defaultValue;
        }
        return strippedParameter;
    };
    return stripProperties(parameter);
};
//# sourceMappingURL=parameters.js.map